export const STATUS_LABELS = {
    submitted: "Submitted",
    new: "Submitted",
    under_review: "Under Review",
    shortlisted: "Shortlisted",
    interview: "Interview",
    selected: "Selected",
    offer: "Offer",
    documentation: "Documentation",
    visa_processing: "Visa Processing",
    placement: "Placement",
    rejected: "Rejected",
    hired: "Hired",
    withdrawn: "Withdrawn",
};

export const STATUS_STYLES = {
    submitted: "border-forest/40 text-forest",
    new: "border-forest/40 text-forest",
    under_review: "border-ink/30 text-ink/60",
    shortlisted: "border-champagne/60 text-[#8a7320]",
    interview: "border-champagne/60 text-[#8a7320]",
    selected: "border-forest/60 text-forest",
    offer: "border-forest/60 text-forest",
    documentation: "border-ink/30 text-ink/60",
    visa_processing: "border-ink/30 text-ink/60",
    placement: "border-forest bg-forest text-ivory",
    rejected: "border-ink/20 text-ink/45",
    hired: "border-forest bg-forest text-ivory",
    withdrawn: "border-ink/15 text-ink/35",
};

export const StatusPill = ({ status }) => (
    <span
        data-testid={`status-pill-${status}`}
        className={`inline-block border px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] ${STATUS_STYLES[status] || STATUS_STYLES.new}`}
    >
        {STATUS_LABELS[status] || status}
    </span>
);

export const formatDate = (iso) =>
    iso
        ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })
        : "—";

export const apiFetch = async (path, options = {}) => {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${path}`, {
        credentials: "include",
        ...options,
    });
    return res;
};
